import axios from 'axios'

export const state = {
    viewDropdown: {},
    viewDropdownList: [],
    dropdownUpdated: false,
}

export const getters = {
  getViewDropdownList: state => state.viewDropdownList,
  getDropdownUpdated: state => state.dropdownUpdated
}

export const actions = {
    async fetchAllDropdowns({ commit }) {
    let response = await axios.get('/api/dropdowns/')
        response = response.data

        commit('SET_ALL_DROPDOWNS', response)
    },
    async updateDropdownList({ commit }, payload) {
        let response = await axios.post('/api/dropdowns/' + payload.id, { ...payload })
        response = response.data

        commit('SET_DROPDOWN_UPDATED', true)
        commit('SET_ALL_DROPDOWNS', response)

        setTimeout(() => {
            commit('SET_DROPDOWN_UPDATED', false)
        }, 500)
        
    }
}

export const mutations = {
  SET_ALL_DROPDOWNS (state, value) {
      state.viewDropdownList = value
  },
  SET_DROPDOWN_UPDATED (state, value) {
    state.dropdownUpdated = value
  },
}


// WEBPACK FOOTER //
// ./resources/js/store/modules/dropdowns.js